export const DEFAULT_PAGE_SIZE = 50;
export const DEFAULT_PAGE_NUM = 1;

export const DEFAULT_PAGINATOR_QUERY = {
  'page.size': DEFAULT_PAGE_SIZE,
  'page.num': DEFAULT_PAGE_NUM,
};

export const OFFLINE_TABLE_PAGE_SIZE = 10_000;

export interface PaginationLimit {
  size: number;
  maxOffset: number;
}

export enum PageLimit {
  Small = 'SMALL',
  Medium = 'MEDIUM',
  Large = 'LARGE',
  Huge = 'HUGE',
  Max = 'MAX',
}

export enum BatchLimit {
  Batch = 'BATCH',
  Bulk = 'BULK',
}

enum BackendTier {
  Storefront = 'STOREFRONT',
  Cabinet = 'CABINET',
  Backoffice = 'BACKOFFICE',
  Export = 'EXPORT',
  Default = 'DEFAULT',
}

enum BackendBatchTier {
  Lookup = 'LOOKUP',
  Bulk = 'BULK',
}

const BACKEND_TIER_LIMITS: Readonly<Record<BackendTier, Readonly<PaginationLimit>>> = {
  [BackendTier.Storefront]: { size: 100, maxOffset: 10_000 } as const,
  [BackendTier.Cabinet]: { size: 200, maxOffset: 50_000 } as const,
  [BackendTier.Backoffice]: { size: 500, maxOffset: 100_000 } as const,
  [BackendTier.Export]: { size: 5_000, maxOffset: 200_000 } as const,
  [BackendTier.Default]: { size: 10_000, maxOffset: 1_000_000 } as const,
};

const BACKEND_BATCH_LIMITS: Readonly<Record<BackendBatchTier, number>> = {
  [BackendBatchTier.Lookup]: 500,
  [BackendBatchTier.Bulk]: 5_000,
};

export const PAGE_LIMITS: Readonly<Record<PageLimit, Readonly<PaginationLimit>>> = {
  [PageLimit.Small]: BACKEND_TIER_LIMITS[BackendTier.Storefront],
  [PageLimit.Medium]: BACKEND_TIER_LIMITS[BackendTier.Cabinet],
  [PageLimit.Large]: BACKEND_TIER_LIMITS[BackendTier.Backoffice],
  [PageLimit.Huge]: BACKEND_TIER_LIMITS[BackendTier.Export],
  [PageLimit.Max]: BACKEND_TIER_LIMITS[BackendTier.Default],
};

export const BATCH_LIMITS: Readonly<Record<BatchLimit, number>> = {
  [BatchLimit.Batch]: BACKEND_BATCH_LIMITS[BackendBatchTier.Lookup],
  [BatchLimit.Bulk]: BACKEND_BATCH_LIMITS[BackendBatchTier.Bulk],
};
